import React from "react";
import Layout from "components/Layout";
import UserDataTable from "./components/UserDataTable";

function User() {
  return (
    <Layout title="사용자 목록">
      <UserDataTable />
    </Layout>
  );
}

export default User;
